import { tw } from "@careinfo/tailwind";
import { useState } from "react";
import { useController } from "react-hook-form";
import SwitchButton from "../SwitchButton";
import { BlockEditor } from "./src/components/BlockEditor";
import "./src/styles/index.css";
import "./src/index.css";

export function RichTextEditor(props: any) {
  const { name, control } = props;
  const [showHtml, setShowHtml] = useState(false);

  const {
    field: { value = "", onChange },
  } = useController({ name, control, defaultValue: "" });

  return (
    <>
      <div
        className={tw`w-full my-2 text-left mt-4 ${props.otherAttributes?.className}`}
      >
        <div className={tw`flex justify-between items-center`}>
          <label className={tw`my-2`} htmlFor="">
            {props.label}
          </label>
        </div>
        <BlockEditor
          onChange={(value: string) => onChange(value)}
          content={value}
          setTableOfContent={(value: string) => {
            props?.setValue("table_of_content", value);
          }}
        />
        {props.errors && (
          <p className={tw`text-red-500 text-xs my-1`}>
            {props.errors?.message}
          </p>
        )}
      </div>
    </>
  );
}
